import React, { useContext } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { DeviceContext } from '../../deviceType';

const RichTextInput = ({
  value,
  handleChange,
}: {
  value: string;
  handleChange: (value: string, name: string) => void;
}) => {
  const size = useContext(DeviceContext);
  const desktopModules = [
    [{ font: [] }],
    [{ header: [1, 2, 3, false] }],
    ['bold', 'italic', 'underline', 'blockquote'],
    [{ script: 'sub' }, { script: 'super' }],
    [{ align: [] }],
    [
      {
        color: [
          '#1a1a1a',
          '#A94064',
          '#ffff',
          '#00000',
          'red',
          'yellow',
          '#2f3d7e',
          '#101920',
          '#990012',
          '#9933ff',
        ],
      },
      {
        background: [
          '#1a1a1a',
          '#A94064',
          '#ffff',
          '#00000',
          'red',
          'yellow',
          '#2f3d7e',
          '#101920',
          '#990012',
          '#9933ff',
        ],
      },
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    ['link'],
    ['clean'],
  ];
  const mobileModules = [
    [{ header: [1, 2, 3, false] }],
    ['bold', 'italic', 'underline', 'blockquote'],
    [{ align: [] }],
    [
      {
        color: [
          '#1a1a1a',
          '#A94064',
          '#ffff',
          '#00000',
          'red',
          'yellow',
          '#2f3d7e',
          '#101920',
          '#990012',
          '#9933ff',
        ],
      },
      {
        background: [
          '#1a1a1a',
          '#A94064',
          '#ffff',
          '#00000',
          'red',
          'yellow',
          '#2f3d7e',
          '#101920',
          '#990012',
          '#9933ff',
        ],
      },
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    ['link'],
    ['clean'],
  ];

  function _handleChange(content: any, delta: any, source: any, editor: any) {
    const data = editor.getHTML();
    handleChange(data, 'details');
  }
  return (
    <div className="h-full">
      <ReactQuill
        className="rich-text"
        theme="snow"
        value={value}
        modules={{
          toolbar: {
            container: size.width >= 768 ? desktopModules : mobileModules,
            handlers: {},
            history: {
              delay: 2000,
              maxStack: 500,
              userOnly: true,
            },
          },
        }}
        onChange={_handleChange}

      >


      </ReactQuill>
    </div>
  );
};

export default RichTextInput;
